import styles from "./Benefits.module.css";
import useHintStore from "../../store/hintStateStore";
import { BenefitsType, BenefitType } from "../../interfaces/benefits/Benefits.type";
import { generateStyleClasses, getGeneralImage, styleHelper } from "../../helpers/commonFunctions";

export default function Benefit({
    item,
}: {
    item: BenefitType;
}) {
    const { setOpen } = useHintStore();
    const icon = item?.icon;
    const title = item?.title;
    const blueLabel = item?.blueLabel;
    const description = item?.description;
    const dashedSeparator = item?.dashedSeparator;
    return (
        <div className={`vas-d-flex vas-flex-column vas-w-100`}>
            <div className={`vas-d-flex vas-flex-column vas-py-3 vas-position-relative`}>
                <div className={`vas-d-flex vas-justify-content-between`}>
                    <div className={`vas-d-flex vas-align-items-center ${generateStyleClasses(title.style)}`}>
                        <img
                            className={`vas vas-d-flex`}
                            src={getGeneralImage(icon)}
                            alt=""
                            width={25}
                            height={25}
                        />
                        <div className={`vas-px-2`}>
                            {title.text}
                        </div>
                    </div>
                    {
                        blueLabel &&
                        (blueLabel?.type == 'text' ?
                            <div
                                style={styleHelper({
                                    color: blueLabel.data?.textColor,
                                })}
                                className={`${generateStyleClasses(blueLabel?.data?.style)} ${styles[`text_sizable_${blueLabel?.data?.style.size}`]}`}>
                                {blueLabel?.data?.text}
                            </div> :
                            <div>
                                <img
                                    className={`vas vas-d-flex`}
                                    src={getGeneralImage(blueLabel?.data?.icon)}
                                    alt=""
                                    width={26}
                                    height={26}
                                />
                            </div>)

                    }
                </div>
                <div className={`vas-d-flex`}>
                    <div
                        className={`vas-text-14 ${styles.description_padding} ${generateStyleClasses(description.style)}`}
                        style={styleHelper({
                            color: description.textColor
                        })}>
                        {description.text}
                    </div>
                </div>
            </div>
            {
                dashedSeparator ? <span
                    className={`vas-dotted-line vas-0`}
                    style={styleHelper({ borderColor: dashedSeparator?.color })}
                /> : ''
            }
        </div>
    );
}
